import WidgetBase from '@dojo/widget-core/WidgetBase';
import { DNode } from '@dojo/widget-core/interfaces';
import { v,w } from '@dojo/widget-core/d';

import Ticker, {allGameInfoResult, memberInfo} from './Ticker';
import PlayerInfo from './PlayerInfo';
import { ActionListProperties } from './ActionList';

import * as css from './styles/GameInfo.m.css';
import * as playercss from './styles/PlayerInfo.m.css';

export interface PlayerInfoParent {
    parent: Ticker;
    actions: ActionListProperties;      // We're not using these, but we want to be re-rendered when they change.
    detailInfo: allGameInfoResult | null;
}

/**
 * Gameinfo: A widget that shows teams, player names, etc.
 * 
 */
export default class GameInfo extends WidgetBase<PlayerInfoParent> {

    constructor() {
        super();
    }
    
    protected render() {
        
        if (this.properties.detailInfo == null) {
            return v('div', {}, [ 'Detail Information wird geladen ...' ]);
        } else {
            var home = this.renderTeam(1, this.properties.detailInfo.team_home.club, this.properties.detailInfo.team_home.team_members, false);
            var guest= this.renderTeam(2, this.properties.detailInfo.team_guest.club, this.properties.detailInfo.team_guest.team_members, true);
            
            return  v('div', { classes: css.gameinfobox }, [
                v('div', { key: 'teamboxleft', id: 'teamboxleft', classes: css.teamboxleft },  home ),
                v('div', { key: 'teamboxright', id: 'teamboxright', classes: css.teamboxright},  guest ),
            ]);
        }
    }
    
    protected renderTeam(teamnumber: number, teamname: string, members: memberInfo[], alignRight: boolean):DNode[] {
        var nodes: DNode[]=[];
        nodes.push(v('div', { classes: css.teamname }, [teamname]));
        nodes.push(v('div', { classes: [ playercss.playerhead ] }, [
                v('div', { title: 'Rückennummer', classes: [ playercss.playerno ]}, [ 'Nr' ]),
                v('div', { title: 'Spielername', classes: [ playercss.playername, ] }, [ 'Name' ] ),
                v('div', { title: 'Geworfene Tore', classes: [ playercss.playergoals  ] }, [ 'Tore' ] ),
                v('div', { title: 'Geworfene und getroffene 7 Meter', classes: [ playercss.player7m  ]}, ["7m"]),
                v('div', { title: 'Karten und Strafen', classes: [ playercss.playerpenalties  ]}, ["Karten und Strafen"]),
        ]));
        // console.log("before sort "+teamnumber);
        members = members.sort(this.membercompare.bind(this));
        // console.log("after sort "+teamnumber);
        for (var member of members) {
            nodes.push(w(PlayerInfo, { player: member, rightToLeft: alignRight, team: teamnumber}));
        }
        return nodes;
    }
    
    protected logMembercompare(a: memberInfo, b: memberInfo) : number {
        var result=this.membercompare(a, b);
        console.log("memberCompare '"+a.player_no+"' to '"+b.player_no+"' is "+result);
        return result;
    }
    
    protected membercompare(a: memberInfo, b:memberInfo):number {
        var aN = parseInt(a.player_no);
        var bN = parseInt(b.player_no);
        
        if (isNaN(aN) && isNaN(bN)) {
            return a.player_no == b.player_no ? 0 : a.player_no > b.player_no ? 1 : -1;
        }
        else if (isNaN(aN)) {
            return 1;
        }
        else if (isNaN(bN)) {
            return -1;
        } else {
            return aN - bN;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/widgets/GameInfo.ts